var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 39,
    viewBox: "0 0 122 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 38.2C2.82609 38.2 4.3913 20.2 6.21739 20.2C8.04348 20.2 9.6087 16.6 11.4348 16.6C13.2609 16.6 14.8261 23 16.6522 23C18.4783 23 20.0435 15.8 21.8696 15.8C23.6957 15.8 25.2609 28.6 27.087 28.6C28.913 28.6 30.4783 12.2 32.3043 12.2C34.1304 12.2 35.6957 25.8 37.5217 25.8C39.3478 25.8 40.913 23.4 42.7391 23.4C44.5652 23.4 46.1304 22.6 47.9565 22.6C49.7826 22.6 51.3478 13.4 53.1739 13.4C55 13.4 56.5652 17.8 58.3913 17.8C60.2174 17.8 61.7826 24.2 63.6087 24.2C65.4348 24.2 67 21.8 68.8261 21.8C70.6522 21.8 72.2174 24.2 74.0435 24.2C75.8696 24.2 77.4348 27.4 79.2609 27.4C81.087 27.4 82.6522 1 84.4783 1C86.3044 1 87.8696 17 89.6957 17C91.5217 17 93.087 13.8 94.913 13.8C96.7391 13.8 98.3043 27.4 100.13 27.4C101.957 27.4 103.522 16.6 105.348 16.6C107.174 16.6 108.739 21 110.565 21C112.391 21 113.957 30.6 115.783 30.6C117.609 30.6 119.174 19.8 121 19.8",
    stroke: "#845ADF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph_icon.87f0bba5bb947c8e8c76f4c2c9d01d6c.svg";
export { ForwardRef as ReactComponent };